export default "__VITE_ASSET__7S1RkVRI__"